// noinspection GraphQLUnresolvedReference

import { gql } from 'graphql-request'

export const FRAGMENT_MONEDA = gql`
  fragment fields on Moneda {
    _id
    codigo
    descripcion
    sigla
    tipoCambio
    tipoCambioCompra
    activo
    state
    usucre
    usumod
    createdAt
    updatedAt
  }
`
